/* Transform Timeline — scroll-driven progress line, dot activation, step fade-in.
   Vanilla JS. Content stays fully visible if JS never runs.
   Uses requestAnimationFrame with a setTimeout fallback so it also works in
   environments where rAF is throttled or frozen. */
(function () {
  'use strict';

  function initTimeline(root) {
    var list = root.querySelector('[data-tt-list]');
    var progress = root.querySelector('[data-tt-progress]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-tt-step]'));
    if (!list || !progress || steps.length === 0) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      progress.style.height = 'calc(100% - 28px)';
      steps.forEach(function (s) {
        s.classList.add('is-reached', 'is-visible');
      });
      return;
    }

    root.classList.add('transform-timeline--animate');

    var ticking = false;

    function update() {
      ticking = false;
      var rect = list.getBoundingClientRect();
      var anchor = window.innerHeight * 0.65;
      var raw = anchor - rect.top;
      var max = rect.height - 28;
      var height = Math.max(0, Math.min(max, raw));
      progress.style.height = height + 'px';

      steps.forEach(function (step) {
        var stepRect = step.getBoundingClientRect();
        var stepTop = stepRect.top - rect.top;
        step.classList.toggle('is-reached', height >= stepTop + 14);
        if (stepRect.top < window.innerHeight * 0.9) {
          step.classList.add('is-visible');
        }
      });
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      var done = false;
      function run() {
        if (done) return;
        done = true;
        update();
      }
      if (window.requestAnimationFrame) window.requestAnimationFrame(run);
      setTimeout(run, 80);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
    setTimeout(update, 300);
  }

  function initAll() {
    document.querySelectorAll('[data-transform-timeline]').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-transform-timeline]');
    if (root) initTimeline(root);
  });
})();
